(function ($) {
	$.fn.tagName = function () {
		return this.prop('tagName');
	}

	$.fn.tagNameLowerCase = function () {
		return this.prop('tagName').toLowerCase();
	}
}(jQuery));